var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFolder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#folder_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M31.262 27.941H2.152c-.96 0-1.738-.749-1.738-1.673V5.525c0-.924.778-1.673 1.738-1.673h8.217a1.75 1.75 0 0 1 1.515.853l.959 1.64a1.75 1.75 0 0 0 1.514.854h16.905c.96 0 1.738.749 1.738 1.673v17.396c0 .924-.778 1.673-1.738 1.673Z",
  fill: "#FFCE7B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.152 27.942h29.11c.96 0 1.738-.75 1.738-1.674V8.873c0-.924-.778-1.674-1.738-1.674H18.7a1.75 1.75 0 0 0-1.514.853l-.959 1.641a1.75 1.75 0 0 1-1.514.853H2.151c-.96 0-1.738.75-1.738 1.674v14.048c0 .925.778 1.674 1.738 1.674Z",
  fill: "#FFCE7B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.975 7.352c.098.21.156.44.156.686v17.395c0 .925-.778 1.674-1.738 1.674H1.283a1.78 1.78 0 0 1-.713-.15 1.74 1.74 0 0 0 1.582.987h29.11c.96 0 1.738-.75 1.738-1.674V8.875c0-.68-.422-1.261-1.025-1.523Z",
  fill: "#FCD462"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "folder_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.414 .207)",
  d: "M0 0h32.586v31.379H0z"
})))));
export { SvgFolder as ReactComponent };
export default __webpack_public_path__ + "bc2697994be39b37147c4c17af6c3eee.svg";